export const WHATSAPP_NUMBER = "529993616898";

export const waLink = (text) =>
  `https://wa.me/${WHATSAPP_NUMBER}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const WA_DISPLAY = "+52 999 361 6898";
